/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify.js'
import router from '@/router/index.js'
import telemetry from '@/js/telemetry/install.js';

export function registerPlugins (app) {
  app
    .use(vuetify)
    .use(router)
    .use(telemetry)
}
